import React, { useCallback } from "react";
import checkZendesk from "../../../hooks/checkZendesk";
import "./HelpCenter.sass";

export default function HelpCenter() {
  const handleOpen = useCallback(() => {
    checkZendesk(() => {
      window.zE("messenger", "open");
    });
  }, []);

  return (
    <button className="helpCenterBtn" type="button" onClick={handleOpen}>
      Help Center
    </button>
  );
}
